import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getSlicedArray'
})
export class GetSlicedArrayPipe implements PipeTransform {
    
    transform(array: any[], qty: number): any[] {
        return array.slice(0, qty);
    }
    
}
